var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!!_vm.columnSchema.headerFlag && (!!_vm.columnSchema.children && _vm.columnSchema.children.length > 0)) ? _c('el-table-column', {
    attrs: {
      "label": _vm.columnSchema.label,
      "align": _vm.columnSchema.align ? _vm.columnSchema.align : 'center'
    }
  }, [_vm._l((_vm.columnSchema.children), function(child) {
    return [_c('table-multi-level-column', {
      attrs: {
        "column-schema": child
      }
    })]
  })], 2) : (!_vm.columnSchema.headerFlag && (_vm.columnSchema.show !== false) && !_vm.columnSchema.children) ? _c('el-table-column', {
    key: _vm.columnSchema.columnId,
    attrs: {
      "prop": _vm.columnSchema.prop,
      "label": _vm.columnSchema.label,
      "sortable": _vm.columnSchema.sortable,
      "fixed": !_vm.columnSchema.fixed ? false : _vm.columnSchema.fixed,
      "align": _vm.columnSchema.align ? _vm.columnSchema.align : 'center',
      "formatter": _vm.formatterValue,
      "format": _vm.columnSchema.format,
      "show-overflow-tooltip": true,
      "width": _vm.columnSchema.width
    }
  }) : _vm._e()
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a6a18fc","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/form-widget/table-multi-level-column.vue
// module id = null
// module chunks = 